import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { PaginationModel, TranslatePipe } from '@spartacus/core';
import { Observable, of, Subscription } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import {
  DownloadCategoryListPayload,
  DownloadCategoryListService,
} from 'src/app/service/downloads/download-category-list.service';
import { DownloadPayload, DownloadsService } from 'src/app/service/downloads/downloads.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { PaginationComponent } from '../pagination/pagination.component';
import { DownloadMediaCategoryListComponent } from './download-media-category-list/download-media-category-list.component';
import { DownloadMediaComponent } from './download-media/download-media.component';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [DownloadMediaCategoryListComponent, DownloadMediaComponent, PaginationComponent, AsyncPipe, TranslatePipe],
})
export class DownloadsComponent implements OnInit, OnDestroy {
  items$: Observable<any>;
  downLoadItems$: Observable<any>;
  languageSubscription: Subscription;
  PaginationModel: PaginationModel = {
    currentPage: 0,
    pageSize: 9,
    sort: null,
    totalPages: 0,
    totalResults: 0,
  };

  downloadsServicepayload: DownloadPayload = {
    type: 'ALL',
    currentPage: 0,
    fields: 'DEFAULT',
    pageSize: 9,
  };

  downloadCategoryListPayload: DownloadCategoryListPayload = {
    type: 'ALL',
    currentPage: 0,
    fields: 'DEFAULT',
    pageSize: 1000,
  };

  constructor(
    private downloadsService: DownloadsService,
    private cdr: ChangeDetectorRef,
    private downloadCategoryListService: DownloadCategoryListService,
    private languageService: ShimanoLanguageService
  ) {}

  ngOnInit() {
    this.languageSubscription = this.languageService
      .getActive()
      .pipe(
        switchMap(() => {
          return this.downloadCategoryListService
            .getDownloadCategoryList(this.downloadCategoryListPayload)
            .pipe(filter(Boolean));
        }),
        tap((downloadItems) => {
          this.downLoadItems$ = of(downloadItems);
        }),

        switchMap(() => this.downloadsService.getDownload(this.downloadsServicepayload).pipe(filter(Boolean))),
        tap((items) => {
          this.items$ = of(items);
          this.updatePaginationModel(items);
        })
      )
      .subscribe(() => this.cdr.detectChanges());
  }

  getDownloadCategry = (typCode: string) => {
    this.downloadsServicepayload.type = typCode;
    this.downloadsServicepayload.currentPage = 0;
    this.loadData();
  };

  loadData = () => {
    this.items$ = this.downloadsService.getDownload(this.downloadsServicepayload).pipe(
      filter(Boolean),
      map((result: any) => {
        this.updatePaginationModel(result);
        return result;
      })
    );
  };

  updatePaginationModel = (result: any) => {
    this.PaginationModel = {
      currentPage: result.pagination.currentPage,
      pageSize: this.downloadsServicepayload.pageSize,
      sort: null,
      totalPages: result.pagination.numberOfPages,
      totalResults: result.pagination.totalNumberOfResults,
    };
  };

  loadCategory = () => {
    this.downLoadItems$ = this.downloadCategoryListService
      .getDownloadCategoryList(this.downloadCategoryListPayload)
      .pipe(
        filter(Boolean),
        map((result: any) => result)
      );
  };

  pageChange(page: any) {
    this.downloadsServicepayload.currentPage = page;
    this.loadData();
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }
}
